
import React from 'react';

function Contact() {
    return (
        <div className='content1'>
            <h2 className="flex-logo">Contact Us</h2>
            <p className="flex-text">Email: contact@aiservices.com</p>
            <p className="flex-text">Phone: 123-456-7890</p>
        </div>
    );
}

export default Contact;
